module.exports = __webpack_public_path__ + "fonts/source-serif-pro-v11-latin-regular.071587b.woff2";